module.exports = __webpack_public_path__ + "static/footer-logo-0e771eb620883294e75020681a1e954e.svg";